<template>
	<div class="content-box">
	<div class="row">
		<div class="col-sm-5">
      <card :id="$route.params.id"  />
      <div class="element-box relative mt-3">
        <navigations :id="$route.params.id" />
      </div>
		</div>
		<div class="col-sm-7">
      <div class="element-box relative">
        <overview :user="$route.params.id" cur="0" />
      </div>
			<activityWidget />
		</div>
	</div>
	</div>
</template>

<script>
    import navigations from '@/components/user/widget/userEditNavigations'
    import card from '@/components/user/profile/card'
    import activityWidget from '@/components/user/widget/activityWidget'
    import overview from '@/components/user/widget/overview'
    export default {
        name: 'UserProfile',
	      components: { activityWidget, card, navigations, overview },
        data () {
            return {
                session: this.$root.session,
                t: this.$root.t,
                isLoading: false,
                uid: 0,
                user: {}
            }
        },
	    mounted () {
            this.uid = this.$route.params.id;
	    },
	    methods: {

	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/profile/index.vue